import React, { useEffect, useState } from 'react';
import { DefaultRouteSelection } from './DefaultRouteSelection';
import { SelectItem, Service } from '../../../types';
import { getServiceRoutes } from './ServiceRoutes';
import { LoadingPage } from '../../Shared';
import { AuthService } from '../../../services';
import { usePromise } from '../../../hooks';

export interface DefaultRouteSelectionContainerProps {
  service?: Service;
  tabIsDefault: boolean;
  tabConfigured: boolean;
  setTabIsDefault: (value: boolean) => any;
  defaultRoute?: string;
  setDefaultRoute: (tabRoute: string) => any;
  loadConnections: () => Promise<any>;
  loadTabIsDefault: () => Promise<any>;
}

export function DefaultRouteSelectionContainer({
  service,
  tabIsDefault,
  tabConfigured,
  setTabIsDefault,
  defaultRoute,
  setDefaultRoute,
  loadConnections,
  loadTabIsDefault,
}: DefaultRouteSelectionContainerProps): JSX.Element {
  const user = usePromise(AuthService.getUser());
  const [items, setItems] = useState<SelectItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      await loadConnections();
      await loadTabIsDefault();
      setLoading(false);
    })().catch(error => console.error(error));
  }, []);

  useEffect(() => {
    const routes = getServiceRoutes(service);
    defaultRoute ?? setDefaultRoute(routes[0]?.value);
    setItems(
      routes.map(tab => ({
        ...tab,
        onClick: () => setDefaultRoute(tab.value),
      }))
    );
  }, [service]);

  if (loading) {
    return <LoadingPage subtext='Configuring services...' fullscreen />;
  }

  return (
    <DefaultRouteSelection
      user={user}
      tabConfigured={tabConfigured}
      items={items}
      selected={defaultRoute}
      tabIsDefault={tabIsDefault}
      setTabIsDefault={setTabIsDefault}
    />
  );
}
